var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4545_64630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 13.333C2.3335 12.0953 2.82516 10.9083 3.70033 10.0332C4.5755 9.15801 5.76249 8.66634 7.00016 8.66634C8.23784 8.66634 9.42483 9.15801 10.3 10.0332C11.1752 10.9083 11.6668 12.0953 11.6668 13.333H10.5002C10.5002 12.4047 10.1314 11.5145 9.47504 10.8581C8.81866 10.2018 7.92842 9.83301 7.00016 9.83301C6.07191 9.83301 5.18167 10.2018 4.52529 10.8581C3.86891 11.5145 3.50016 12.4047 3.50016 13.333H2.3335ZM7.00016 8.08301C5.06641 8.08301 3.50016 6.51676 3.50016 4.58301C3.50016 2.64926 5.06641 1.08301 7.00016 1.08301C8.93391 1.08301 10.5002 2.64926 10.5002 4.58301C10.5002 6.51676 8.93391 8.08301 7.00016 8.08301ZM7.00016 6.91634C8.28933 6.91634 9.3335 5.87217 9.3335 4.58301C9.3335 3.29384 8.28933 2.24967 7.00016 2.24967C5.711 2.24967 4.66683 3.29384 4.66683 4.58301C4.66683 5.87217 5.711 6.91634 7.00016 6.91634Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4545_64630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLine);
export default __webpack_public_path__ + "static/media/user-line.8bb972adada3f573fd05cd01ef2ce4ae.svg";
export { ForwardRef as ReactComponent };